module.exports = __webpack_public_path__ + "img/pro_two_10.b686bc51.jpg";